import axios from 'axios'
import { isAdminSessionExpired, isAdminUser } from './adminSession'

// export const API_BASE_URL = "http://localhost:8081/api/v1/"
// export const AUTH_API_BASE_URL = "http://localhost:8081/api/auth/"
// export const PUBLIC_API_BASE_URL = "http://localhost:8081/api/v1/public/"
// export const USER_API_BASE_URL = "http://localhost:8081/api/v1/user/"

export const API_BASE_URL="https://igaartech.com/inari-server/api/v1/";
export const AUTH_API_BASE_URL = "https://igaartech.com/inari-server/api/auth/";
export const PUBLIC_API_BASE_URL = "https://igaartech.com/inari-server/api/v1/public/";
export const USER_API_BASE_URL = "https://igaartech.com/inari-server/api/v1/user/";

const jwt = localStorage.getItem("jwt")

export const api = axios.create({
    baseURL: AUTH_API_BASE_URL,
    headers: {
        "Authorization": `Bearer ${jwt}`,
        'Content-Type': "application/json"
    }
})
// Default axios instances
export const publicAxios = axios.create({
    baseURL: PUBLIC_API_BASE_URL,
})

export const authAxios = axios.create({
    baseURL: AUTH_API_BASE_URL,
})

export const privateAxios = axios.create({
    baseURL: API_BASE_URL
})

// ✅ Request interceptor – always take fresh jwt
privateAxios.interceptors.request.use((config) => {
    const jwt = localStorage.getItem("jwt")
    if (jwt) {
        config.headers["Authorization"] = `Bearer ${jwt}`;
    }
    return config
}, (error) => Promise.reject(error))

// ✅ Response interceptor – handle 401 & refresh token
privateAxios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            if (isAdminUser() && isAdminSessionExpired()) {
                return Promise.reject(error);
            }

            originalRequest._retry = true;
            const refreshToken = localStorage.getItem('refreshJwt');

            if (!refreshToken) {
                localStorage.clear();
                return Promise.reject(error);
            }

            try {
                const response = await axios.post(`${AUTH_API_BASE_URL}refresh`, { refreshToken });
                const newAccessToken = response.data.jwt;

                localStorage.setItem('jwt', newAccessToken);

                // retry request with new token
                originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
                return privateAxios(originalRequest);

            } catch (err) {
                localStorage.clear();
                return Promise.reject(err);
            }
        }

        return Promise.reject(error);
    }
);
